var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Button, Tooltip, tooltipAsLabelBehavior, AcceptIcon, AddIcon, ApprovalsAppbarIcon, AppsIcon, ArchiveIcon, ArrowDownIcon, ArrowLeftIcon, ArrowRightIcon, ArrowSortIcon, ArrowUpIcon, AudienceIcon, AudioLoadingIcon, AudioOffIcon, AttendeeIcon, BanIcon, BellIcon, BellSlashIcon, BellSnoozeIcon, BluetoothIcon, BoldIcon, BookmarkIcon, BreakoutRoomIcon, BroadcastIcon, BroadcastViewFullscreenIcon, BroadcastViewLeftIcon, BulletsIcon, CalendarIcon, CalendarAgendaIcon, CallBlockedIcon, CallControlCloseTrayIcon, CallControlReleaseIcon, CallControlRequestIcon, CallControlPresentNewIcon, CallControlShareIcon, CallControlStopPresentingNewIcon, CallDialpadIcon, CallEndIcon, CallIcon, CallPstnIcon, CallRecordingIcon, CallVideoIcon, CallVideoOffIcon, CameraIcon, CanvasAddPageIcon, CallMissedLineIcon, CallParkingIcon, CastingIcon, ChannelShareIcon, ChatIcon, ChatOffIcon, CheckmarkCircleIcon, ChevronDownIcon, ChevronDownMediumIcon, ChevronEndIcon, ChevronEndMediumIcon, ChevronStartIcon, CircleIcon, ClipboardCopiedToIcon, ClosedCaptionsIcon, CloseIcon, CodeSnippetIcon, CollapseIcon, CompanionIcon, ComposeIcon, ComputerAudioIcon, ComputerAudioOffIcon, ConferenceRoomDeviceIcon, ContactCardIcon, ContactGroupCallIcon, ContactGroupIcon, ContentIcon, CustomerHubIcon, DoorArrowLeftIcon, DownloadIcon, EditIcon, EmailIcon, EmailWithDotIcon, EmojiIcon, EmojiSadIcon, EmojiSurprisedIcon, ErrorIcon, ExcelColorIcon, ExcelIcon, ExclamationCircleIcon, ExclamationTriangleIcon, ExpandIcon, EyeIcon, EyeFriendlierIcon, EyeSlashIcon, FilesAftereffectsIcon, FilesCodeIcon, FilesEmptyIcon, FilesErrorIcon, FilesFlashIcon, FilesGenericColoredIcon, FilesGifIcon, FilesHtmlColoredIcon, FilesIllustratorIcon, FilesImageIcon, FilesIndesignIcon, FilesOneNoteIcon, FilesPdfColoredIcon, FilesPdfIcon, FilesPhotoshopIcon, FilesPictureColoredIcon, FilesSketchIcon, FilesSoundIcon, FilesTextColoredIcon, FilesTxtIcon, FilesUploadIcon, FilesVideoIcon, FilesZipIcon, FilterIcon, FlagIcon, FluidIcon, FluidFileIcon, FontColorIcon, FontSizeIcon, FormatIcon, GalleryIcon, GalleryNewIcon, GalleryNewLargeIcon, GeofenceArrivesIcon, GeofenceLeavesIcon, GeofenceArrivesOrLeavesIcon, GiphyIcon, GlassesIcon, GridIcon, GroupVideoCallGridIcon, HandIcon, HeadsetIcon, HighlightIcon, HorizontalRuleIcon, ImageAltTextIcon, ImageLibraryIcon, ImageUnavailableIcon, IndentIcon, InfoIcon, ItalicIcon, LeaveIcon, LightningIcon, LikeIcon, LinkIcon, LiveIcon, LiveOffIcon, LocationIcon, LockIcon, MarkAsUnreadIcon, MeetingNewIcon, MeetingTimeIcon, MegaphoneIcon, MentionIcon, MenuIcon, MergeCallsIcon, MessageSeenIcon, MicIcon, MicOffIcon, MicrophoneDisabledIcon, MicrosoftStreamIcon, MoreIcon, NoPresenterIcon, NotepadPersonIcon, NotesIcon, NotificationsMutedIcon, NumberListIcon, OcrOffIcon, OcrOnIcon, OneNoteColorIcon, OneNoteIcon, OneNoteMonoIcon, OneDriveIcon, OptionsIcon, OutdentIcon, OutlookColorIcon, OpenOutsideIcon, PanoramaIcon, PanoramaOffIcon, PaperclipIcon, ParticipantAddIcon, ParticipantRemoveIcon, PauseIcon, PauseThickIcon, PhoneArrowIcon, PhoneClockIcon, PhoneIcon, PlayIcon, PlugsIcon, PollIcon, PopupIcon, PowerPointColorIcon, PowerPointIcon, PresenceAvailableIcon, PresenceStrokeIcon, PresenterIcon, QnaIcon, QuestionCircleIcon, QuoteIcon, RadioButtonIcon, ReadAloudIcon, RaiseHandColoredIcon, RaiseHandDisabledIcon, RaiseHandIcon, ReactionsIcon, RedbangIcon, RedoIcon, RemoveFormatIcon, ReplyIcon, RetryIcon, RobotIcon, SaveIcon, ScreencastIcon, ScreenshareIcon, SearchIcon, SendIcon, SettingsIcon, SettingsAudioIcon, ShareAltIcon, ShareGenericIcon, ShareLocationIcon, ShareToIcon, ShieldKeyholeIcon, Shift24hIcon, ShiftActivityIcon, SkypeColorIcon, SkypeLogoIcon, SpeakerMuteIcon, SpeakerPersonIcon, SpotlightIcon, SpotlightStopIcon, StarIcon, StickerIcon, StrikeIcon, SurveyIcon, SwitchCameraIcon, SyncIcon, TableAddIcon, TableDeleteIcon, TableIcon, TabsIcon, TagIcon, TeamCreateIcon, TeamsIcon, TeamsMonochromeIcon, TenantWorkIcon, TenantPersonalIcon, ThumbtackIcon, ThumbtackSlashIcon, TiltPanZoomIcon, ToDoListIcon, TranscriptIcon, TranslationIcon, TrashCanIcon, TriangleEndIcon, TriangleDownIcon, TriangleUpIcon, TvIcon, UnderlineIcon, UndoIcon, UrgentIcon, UserBlurIcon, UserFriendsIcon, UserPhoneIcon, VideoCameraEmphasisIcon, VideoLoadingIcon, VideomailIcon, VideoProhibitedIcon, VisioColorIcon, VisioIcon, VolumeIcon, VolumeDownIcon, VolumeUpIcon, WandIcon, WhiteboardIcon, WindowMaximizeIcon, WindowMinimizeIcon, WindowRestoreIcon, WordColorIcon, WordIcon, WorkOrSchoolIcon, YammerIcon, ZoomInIcon, ZoomOutIcon, ZoomToFitIcon, } from "@fluentui/react-northstar";
import { getText } from "../translations";
var Icons = {
    AcceptIcon: AcceptIcon,
    AddIcon: AddIcon,
    ApprovalsAppbarIcon: ApprovalsAppbarIcon,
    AppsIcon: AppsIcon,
    ArchiveIcon: ArchiveIcon,
    ArrowDownIcon: ArrowDownIcon,
    ArrowLeftIcon: ArrowLeftIcon,
    ArrowRightIcon: ArrowRightIcon,
    ArrowSortIcon: ArrowSortIcon,
    ArrowUpIcon: ArrowUpIcon,
    AudienceIcon: AudienceIcon,
    AudioLoadingIcon: AudioLoadingIcon,
    AudioOffIcon: AudioOffIcon,
    AttendeeIcon: AttendeeIcon,
    BanIcon: BanIcon,
    BellIcon: BellIcon,
    BellSlashIcon: BellSlashIcon,
    BellSnoozeIcon: BellSnoozeIcon,
    BluetoothIcon: BluetoothIcon,
    BoldIcon: BoldIcon,
    BookmarkIcon: BookmarkIcon,
    BreakoutRoomIcon: BreakoutRoomIcon,
    BroadcastIcon: BroadcastIcon,
    BroadcastViewFullscreenIcon: BroadcastViewFullscreenIcon,
    BroadcastViewLeftIcon: BroadcastViewLeftIcon,
    BulletsIcon: BulletsIcon,
    CalendarIcon: CalendarIcon,
    CalendarAgendaIcon: CalendarAgendaIcon,
    CallBlockedIcon: CallBlockedIcon,
    CallControlCloseTrayIcon: CallControlCloseTrayIcon,
    CallControlReleaseIcon: CallControlReleaseIcon,
    CallControlRequestIcon: CallControlRequestIcon,
    CallControlPresentNewIcon: CallControlPresentNewIcon,
    CallControlShareIcon: CallControlShareIcon,
    CallControlStopPresentingNewIcon: CallControlStopPresentingNewIcon,
    CallDialpadIcon: CallDialpadIcon,
    CallEndIcon: CallEndIcon,
    CallIcon: CallIcon,
    CallPstnIcon: CallPstnIcon,
    CallRecordingIcon: CallRecordingIcon,
    CallVideoIcon: CallVideoIcon,
    CallVideoOffIcon: CallVideoOffIcon,
    CameraIcon: CameraIcon,
    CanvasAddPageIcon: CanvasAddPageIcon,
    CallMissedLineIcon: CallMissedLineIcon,
    CallParkingIcon: CallParkingIcon,
    CastingIcon: CastingIcon,
    ChannelShareIcon: ChannelShareIcon,
    ChatIcon: ChatIcon,
    ChatOffIcon: ChatOffIcon,
    CheckmarkCircleIcon: CheckmarkCircleIcon,
    ChevronDownIcon: ChevronDownIcon,
    ChevronDownMediumIcon: ChevronDownMediumIcon,
    ChevronEndIcon: ChevronEndIcon,
    ChevronEndMediumIcon: ChevronEndMediumIcon,
    ChevronStartIcon: ChevronStartIcon,
    CircleIcon: CircleIcon,
    ClipboardCopiedToIcon: ClipboardCopiedToIcon,
    ClosedCaptionsIcon: ClosedCaptionsIcon,
    CloseIcon: CloseIcon,
    CodeSnippetIcon: CodeSnippetIcon,
    CollapseIcon: CollapseIcon,
    CompanionIcon: CompanionIcon,
    ComposeIcon: ComposeIcon,
    ComputerAudioIcon: ComputerAudioIcon,
    ComputerAudioOffIcon: ComputerAudioOffIcon,
    ConferenceRoomDeviceIcon: ConferenceRoomDeviceIcon,
    ContactCardIcon: ContactCardIcon,
    ContactGroupCallIcon: ContactGroupCallIcon,
    ContactGroupIcon: ContactGroupIcon,
    ContentIcon: ContentIcon,
    CustomerHubIcon: CustomerHubIcon,
    DoorArrowLeftIcon: DoorArrowLeftIcon,
    DownloadIcon: DownloadIcon,
    EditIcon: EditIcon,
    EmailIcon: EmailIcon,
    EmailWithDotIcon: EmailWithDotIcon,
    EmojiIcon: EmojiIcon,
    EmojiSadIcon: EmojiSadIcon,
    EmojiSurprisedIcon: EmojiSurprisedIcon,
    ErrorIcon: ErrorIcon,
    ExcelColorIcon: ExcelColorIcon,
    ExcelIcon: ExcelIcon,
    ExclamationCircleIcon: ExclamationCircleIcon,
    ExclamationTriangleIcon: ExclamationTriangleIcon,
    ExpandIcon: ExpandIcon,
    EyeIcon: EyeIcon,
    EyeFriendlierIcon: EyeFriendlierIcon,
    EyeSlashIcon: EyeSlashIcon,
    FilesAftereffectsIcon: FilesAftereffectsIcon,
    FilesCodeIcon: FilesCodeIcon,
    FilesEmptyIcon: FilesEmptyIcon,
    FilesErrorIcon: FilesErrorIcon,
    FilesFlashIcon: FilesFlashIcon,
    FilesGenericColoredIcon: FilesGenericColoredIcon,
    FilesGifIcon: FilesGifIcon,
    FilesHtmlColoredIcon: FilesHtmlColoredIcon,
    FilesIllustratorIcon: FilesIllustratorIcon,
    FilesImageIcon: FilesImageIcon,
    FilesIndesignIcon: FilesIndesignIcon,
    FilesOneNoteIcon: FilesOneNoteIcon,
    FilesPdfColoredIcon: FilesPdfColoredIcon,
    FilesPdfIcon: FilesPdfIcon,
    FilesPhotoshopIcon: FilesPhotoshopIcon,
    FilesPictureColoredIcon: FilesPictureColoredIcon,
    FilesSketchIcon: FilesSketchIcon,
    FilesSoundIcon: FilesSoundIcon,
    FilesTextColoredIcon: FilesTextColoredIcon,
    FilesTxtIcon: FilesTxtIcon,
    FilesUploadIcon: FilesUploadIcon,
    FilesVideoIcon: FilesVideoIcon,
    FilesZipIcon: FilesZipIcon,
    FilterIcon: FilterIcon,
    FlagIcon: FlagIcon,
    FluidIcon: FluidIcon,
    FluidFileIcon: FluidFileIcon,
    FontColorIcon: FontColorIcon,
    FontSizeIcon: FontSizeIcon,
    FormatIcon: FormatIcon,
    GalleryIcon: GalleryIcon,
    GalleryNewIcon: GalleryNewIcon,
    GalleryNewLargeIcon: GalleryNewLargeIcon,
    GeofenceArrivesIcon: GeofenceArrivesIcon,
    GeofenceLeavesIcon: GeofenceLeavesIcon,
    GeofenceArrivesOrLeavesIcon: GeofenceArrivesOrLeavesIcon,
    GiphyIcon: GiphyIcon,
    GlassesIcon: GlassesIcon,
    GridIcon: GridIcon,
    GroupVideoCallGridIcon: GroupVideoCallGridIcon,
    HandIcon: HandIcon,
    HeadsetIcon: HeadsetIcon,
    HighlightIcon: HighlightIcon,
    HorizontalRuleIcon: HorizontalRuleIcon,
    ImageAltTextIcon: ImageAltTextIcon,
    ImageLibraryIcon: ImageLibraryIcon,
    ImageUnavailableIcon: ImageUnavailableIcon,
    IndentIcon: IndentIcon,
    InfoIcon: InfoIcon,
    ItalicIcon: ItalicIcon,
    LeaveIcon: LeaveIcon,
    LightningIcon: LightningIcon,
    LikeIcon: LikeIcon,
    LinkIcon: LinkIcon,
    LiveIcon: LiveIcon,
    LiveOffIcon: LiveOffIcon,
    LocationIcon: LocationIcon,
    LockIcon: LockIcon,
    MarkAsUnreadIcon: MarkAsUnreadIcon,
    MeetingNewIcon: MeetingNewIcon,
    MeetingTimeIcon: MeetingTimeIcon,
    MegaphoneIcon: MegaphoneIcon,
    MentionIcon: MentionIcon,
    MenuIcon: MenuIcon,
    MergeCallsIcon: MergeCallsIcon,
    MessageSeenIcon: MessageSeenIcon,
    MicIcon: MicIcon,
    MicOffIcon: MicOffIcon,
    MicrophoneDisabledIcon: MicrophoneDisabledIcon,
    MicrosoftStreamIcon: MicrosoftStreamIcon,
    MoreIcon: MoreIcon,
    NoPresenterIcon: NoPresenterIcon,
    NotepadPersonIcon: NotepadPersonIcon,
    NotesIcon: NotesIcon,
    NotificationsMutedIcon: NotificationsMutedIcon,
    NumberListIcon: NumberListIcon,
    OcrOffIcon: OcrOffIcon,
    OcrOnIcon: OcrOnIcon,
    OneNoteColorIcon: OneNoteColorIcon,
    OneNoteIcon: OneNoteIcon,
    OneNoteMonoIcon: OneNoteMonoIcon,
    OneDriveIcon: OneDriveIcon,
    OptionsIcon: OptionsIcon,
    OutdentIcon: OutdentIcon,
    OutlookColorIcon: OutlookColorIcon,
    OpenOutsideIcon: OpenOutsideIcon,
    PanoramaIcon: PanoramaIcon,
    PanoramaOffIcon: PanoramaOffIcon,
    PaperclipIcon: PaperclipIcon,
    ParticipantAddIcon: ParticipantAddIcon,
    ParticipantRemoveIcon: ParticipantRemoveIcon,
    PauseIcon: PauseIcon,
    PauseThickIcon: PauseThickIcon,
    PhoneArrowIcon: PhoneArrowIcon,
    PhoneClockIcon: PhoneClockIcon,
    PhoneIcon: PhoneIcon,
    PlayIcon: PlayIcon,
    PlugsIcon: PlugsIcon,
    PollIcon: PollIcon,
    PopupIcon: PopupIcon,
    PowerPointColorIcon: PowerPointColorIcon,
    PowerPointIcon: PowerPointIcon,
    PresenceAvailableIcon: PresenceAvailableIcon,
    PresenceStrokeIcon: PresenceStrokeIcon,
    PresenterIcon: PresenterIcon,
    QnaIcon: QnaIcon,
    QuestionCircleIcon: QuestionCircleIcon,
    QuoteIcon: QuoteIcon,
    RadioButtonIcon: RadioButtonIcon,
    ReadAloudIcon: ReadAloudIcon,
    RaiseHandColoredIcon: RaiseHandColoredIcon,
    RaiseHandDisabledIcon: RaiseHandDisabledIcon,
    RaiseHandIcon: RaiseHandIcon,
    ReactionsIcon: ReactionsIcon,
    RedbangIcon: RedbangIcon,
    RedoIcon: RedoIcon,
    RemoveFormatIcon: RemoveFormatIcon,
    ReplyIcon: ReplyIcon,
    RetryIcon: RetryIcon,
    RobotIcon: RobotIcon,
    SaveIcon: SaveIcon,
    ScreencastIcon: ScreencastIcon,
    ScreenshareIcon: ScreenshareIcon,
    SearchIcon: SearchIcon,
    SendIcon: SendIcon,
    SettingsIcon: SettingsIcon,
    SettingsAudioIcon: SettingsAudioIcon,
    ShareAltIcon: ShareAltIcon,
    ShareGenericIcon: ShareGenericIcon,
    ShareLocationIcon: ShareLocationIcon,
    ShareToIcon: ShareToIcon,
    ShieldKeyholeIcon: ShieldKeyholeIcon,
    Shift24hIcon: Shift24hIcon,
    ShiftActivityIcon: ShiftActivityIcon,
    SkypeColorIcon: SkypeColorIcon,
    SkypeLogoIcon: SkypeLogoIcon,
    SpeakerMuteIcon: SpeakerMuteIcon,
    SpeakerPersonIcon: SpeakerPersonIcon,
    SpotlightIcon: SpotlightIcon,
    SpotlightStopIcon: SpotlightStopIcon,
    StarIcon: StarIcon,
    StickerIcon: StickerIcon,
    StrikeIcon: StrikeIcon,
    SurveyIcon: SurveyIcon,
    SwitchCameraIcon: SwitchCameraIcon,
    SyncIcon: SyncIcon,
    TableAddIcon: TableAddIcon,
    TableDeleteIcon: TableDeleteIcon,
    TableIcon: TableIcon,
    TabsIcon: TabsIcon,
    TagIcon: TagIcon,
    TeamCreateIcon: TeamCreateIcon,
    TeamsIcon: TeamsIcon,
    TeamsMonochromeIcon: TeamsMonochromeIcon,
    TenantWorkIcon: TenantWorkIcon,
    TenantPersonalIcon: TenantPersonalIcon,
    ThumbtackIcon: ThumbtackIcon,
    ThumbtackSlashIcon: ThumbtackSlashIcon,
    TiltPanZoomIcon: TiltPanZoomIcon,
    ToDoListIcon: ToDoListIcon,
    TranscriptIcon: TranscriptIcon,
    TranslationIcon: TranslationIcon,
    TrashCanIcon: TrashCanIcon,
    TriangleEndIcon: TriangleEndIcon,
    TriangleDownIcon: TriangleDownIcon,
    TriangleUpIcon: TriangleUpIcon,
    TvIcon: TvIcon,
    UnderlineIcon: UnderlineIcon,
    UndoIcon: UndoIcon,
    UrgentIcon: UrgentIcon,
    UserBlurIcon: UserBlurIcon,
    UserFriendsIcon: UserFriendsIcon,
    UserPhoneIcon: UserPhoneIcon,
    VideoCameraEmphasisIcon: VideoCameraEmphasisIcon,
    VideoLoadingIcon: VideoLoadingIcon,
    VideomailIcon: VideomailIcon,
    VideoProhibitedIcon: VideoProhibitedIcon,
    VisioColorIcon: VisioColorIcon,
    VisioIcon: VisioIcon,
    VolumeIcon: VolumeIcon,
    VolumeDownIcon: VolumeDownIcon,
    VolumeUpIcon: VolumeUpIcon,
    WandIcon: WandIcon,
    WhiteboardIcon: WhiteboardIcon,
    WindowMaximizeIcon: WindowMaximizeIcon,
    WindowMinimizeIcon: WindowMinimizeIcon,
    WindowRestoreIcon: WindowRestoreIcon,
    WordColorIcon: WordColorIcon,
    WordIcon: WordIcon,
    WorkOrSchoolIcon: WorkOrSchoolIcon,
    YammerIcon: YammerIcon,
    ZoomInIcon: ZoomInIcon,
    ZoomOutIcon: ZoomOutIcon,
    ZoomToFitIcon: ZoomToFitIcon,
};
export var FocusableIcon = function (_a) {
    var content = _a.tooltip.content, locale = _a.locale, styles = _a.styles, iconProps = __rest(_a, ["tooltip", "locale", "styles"]);
    return (React.createElement(Tooltip, { content: getText(locale, content), accessibility: tooltipAsLabelBehavior, trigger: React.createElement(Button, { text: true, styles: __assign(__assign({}, styles), { padding: "0.0625rem", height: "auto" }) },
            React.createElement(Icon, __assign({}, iconProps))) }));
};
var Icon = function (_a) {
    var icon = _a.icon, styles = _a.styles;
    var componentName = "".concat(icon, "Icon");
    if (Icons.hasOwnProperty(componentName)) {
        var IconComponent = Icons[componentName];
        return React.createElement(IconComponent, { outline: true, styles: styles });
    }
    else {
        if (process.env.NODE_ENV === "development")
            console.warn("No such icon available: ", icon);
        return null;
    }
};
export default Icon;
//# sourceMappingURL=Icon.js.map